import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
} from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import { TabClaseProducDeclara } from "./modalTabClaseProducDeclara";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScroll";
import {
  calculoMontoPagar,
  sumaDatos,
} from "../../util/OperacionesDeclaracion";
import moment from "moment";
import axios from "axios";
import TablaDeudaProduc from "./tablaDeudaProduc";
import TablaHistoricoProduc from "./historicoDeudaProduc";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";

export const ModalDeclararProdu = (props) => {
  const headCells = [
    {
      id: "codigo",
      label: "CÓDIGO",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "DESCRIPCIÓN DE LA ACTIVIDAD",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "alicuota",
      label: "ALICUOTA",
      width: "10px",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "montodeclarado",
      label: "MONTO DECLARADO",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "montodeclarar",
      label: "MONTO A PAGAR",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "fecha",
      label: "FECHA DECLARACIÓN",
      textAlign: "center",
      background: "#019cd5",
      fontSize: "10px",
      color: "white",
    },
  ];

  /*  variables de estados */

  const btnCancela = useRef();
  const btnSalir = useRef();
  const btnProcesar = useRef();
  const btnImprimir = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [permisoElimDecla, setPermisoElimDecla] = useState();
  const [permisoAcred, setPermisoAcred] = useState();
  const [desde, setDesde] = useState(0);
  const [idDjur, setIdDjur] = useState(0);
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [body, setBody] = useState(null);

  const txtIdAgente = useRef();
  const txtRitm = useRef();
  const cmbMes = useRef();
  const cmbAnio = useRef();
  const cmbQuincena = useRef();
  const txtDenominacionCome = useRef();
  const txtRif = useRef();
  const txtTlfContri = useRef();
  const txtNumLicencia = useRef();
  const txtSectorCatastral = useRef();
  const txtDireccionContri = useRef();
  const txtNombreRespon = useRef();
  const txtCedula = useRef();
  const txtEstimado = useRef();
  const txtSaldoFavor = useRef();
  const txtReintegro = useRef();
  const txtRetenciones = useRef();
  const txtCreditoFiscal = useRef();
  const txtPorceDescuento = useRef();
  const txtTotalImpuesto = useRef();
  const txtRecargo = useRef();
  const txtIntereses = useRef();
  const txtMulta = useRef();
  const txtDeducible = useRef();
  const txtMontoDescuento = useRef();
  const txtMontoTotal = useRef();

  const txtApellidoRespon = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [contar3, setContar3] = useState(1);
  const [contar4, setContar4] = useState(1);
  const [contar5, setContar5] = useState(0);
  const [contar6, setContar6] = useState(0);
  const [contar7, setContar7] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [deshabilitadoP, setDeshabilitadoP] = useState(true);
  const [deshabilitadoI, setDeshabilitadoI] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [anio, setAnio] = useState([]);
  const [comerAct, setComerAct] = useState();
  const [claseProdxAgen, setClaseProdxAgen] = useState();
  const [repreAct, setRepreAct] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [liquidador, setLiquidador] = useState(
    localStorage.getItem("liquidador")
  );
  const [declaWeb, setDeclaWeb] = useState();
  const [creditoCome, setCreditoCome] = useState("0,00");

  const [radioTipo, setRadioTipo] = useState("1");
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [datoUT, setDatoUT] = useState([]);
  const [datoCalculo, setDatoCalculo] = useState([]);
  const [visibleDefi, setVisibleDefi] = useState("hidden");
  const [visibleRegu, setVisibleRegu] = useState("visible");
  const [visibleCmbQ, setVisibleCmbQ] = useState("hidden");

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [url, setUrl] = useState("");

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const styleInput = {
    backgroundColor: "#ffff",
    color: "#444242",
  };

  const styleInputDirec = {
    backgroundColor: "#ffff",
    color: "#444242",
    height: 27,
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const selectDjurada = (idagente, anio, mes, tipo) => {
    let endpoint = `${op.conexion}/api/produccion/djuradaproduccionagente?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var totImpu = parseFloat("0.00");
          var monDedu = parseFloat("0.00");
          var sfavor = parseFloat("0.00");
          var totPagar = parseFloat("0.00");
          var monEst = parseFloat("0.00");
          setContar4(1);
          setIdDjur(0);
          setRecords(response.data);
          if (response.data.length > 0) {
            setDeshabilitado(true);
            setDeshabilitadoI(true);
            setIdDjur(response.data[0].iddjuradaproduccion);
            for (let a = 0; a < response.data.length; a++) {
              totImpu += parseFloat(response.data[a].montoapagar);
            }

            //monDedu = parseFloat(response.data[0].reintegro) + parseFloat(response.data[0].retenciones) + parseFloat(response.data[0].creditofavor) + parseFloat(response.data[0].montodescuento);
            monDedu =
              parseFloat(response.data[0].retenciones) +
              parseFloat(response.data[0].creditofavor);
            totPagar =
              totImpu +
              parseFloat(response.data[0].recargo) +
              parseFloat(response.data[0].interes) +
              parseFloat(response.data[0].multa) -
              monDedu;
            //txtReintegro.current.value = formatMoneda(response.data[0].reintegro.toString().replace('.', ','), ',', '.', 2);
            txtRetenciones.current.value = formatMoneda(
              response.data[0].retenciones.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtCreditoFiscal.current.value = formatMoneda(
              response.data[0].creditofavor.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtTotalImpuesto.current.value = formatMoneda(
              totImpu.toFixed(2).toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtRecargo.current.value = formatMoneda(
              response.data[0].recargo.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtIntereses.current.value = formatMoneda(
              response.data[0].interes.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtMulta.current.value = formatMoneda(
              response.data[0].multa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtDeducible.current.value = formatMoneda(
              monDedu.toFixed(2).toString().replace(".", ","),
              ",",
              ".",
              2
            );
            if (totPagar < 0) {
              txtSaldoFavor.current.value = formatMoneda(
                (totPagar * -1).toFixed(2).toString().replace(".", ","),
                ",",
                ".",
                2
              );
              txtMontoTotal.current.value = "0,00";
              sfavor = (totPagar * -1).toFixed(2);
            } else {
              txtSaldoFavor.current.value = "0,00";
              txtMontoTotal.current.value = formatMoneda(
                totPagar.toFixed(2).toString().replace(".", ","),
                ",",
                ".",
                2
              );
              sfavor = parseFloat("0.00").toFixed(2);
            }
          } else {
            setDeshabilitado(false);
            setDeshabilitadoI(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectDatCal = (idagente, anio, mes, tipo, fecha) => {
    let endpoint = `${op.conexion}/api/produccion/datoscalculodeclaproduccion?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDatoCalculo(response.data);
          setDeshabilitadoI(true);
          let data = [...records];
          var resu = [];
          let tipDec =
            radioTipo === "3" && cmbQuincena.current.value === "2"
              ? "4"
              : radioTipo;
          resu = sumaDatos(
            records,
            cmbAnio.current.value,
            cmbMes.current.value,
            response.data,
            tipDec,
            espiritu,
            txtRetenciones.current.value,
            txtReintegro.current.value
          );

          txtReintegro.current.value = resu[0].acredit;
          txtCreditoFiscal.current.value = resu[0].credito;
          //txtPorceDescuento.current.value = formatMoneda(response.data.porcebenef.toString().replace('.', ','), ',', '.', 2);
          txtTotalImpuesto.current.value = resu[0].impuesto;
          txtRecargo.current.value = resu[0].recargos;
          txtIntereses.current.value = resu[0].intereses;
          txtMulta.current.value = resu[0].multa;
          txtDeducible.current.value = resu[0].montodeducible;
          //txtMontoDescuento.current.value = resu[0].montodescuento;
          txtSaldoFavor.current.value = resu[0].saldofavor;
          txtMontoTotal.current.value = resu[0].totalpagar;
          /*if (tipDec === '1') {
                    txtEstimado.current.value = formatMoneda(response.data.montoestimado.toString().replace('.', ','), ',', '.', 2);
                } else {
                    txtEstimado.current.value = '0,00';
                }*/
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectUT = (idagente, anio, mes, tipo, fecha, totdeuda) => {
    let endpoint = `${op.conexion}/api/produccion/valorutproduccion?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&totdeuda=${totdeuda}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDatoUT(response.data);
          let data = [...props.tabclaseprodxagen];
          var resu = [];
          let tipDec =
            radioTipo === "2" && cmbQuincena.current.value === "2"
              ? "3"
              : radioTipo;

          resu = calculoMontoPagar(
            props.tabclaseprodxagen,
            response.data,
            cmbAnio.current.value,
            tipDec,
            props.config.calculaminimo
          );
          for (let i = 0; i < resu.length; i++) {
            for (let x = 0; x < resu[i].activi.length; x++) {
              if (operacion === 1) {
                data[x].montoapagar = "0.00";
                data[x].montodeclarado = "0.00";
              } else {
                data[x].montoapagar = resu[i].activi[x].montoapagar;
              }
            }
          }
          setClaseProdxAgen(data);
          setMostrar2(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectDeudaAgenProd = (idagente) => {
    //let endpoint = `${op.conexion}/api/produccion/deudaproduccion?idagente=${idagente}&fecha=${fechaSistema}`;
    let endpoint = `${
      op.conexion
    }/api/minas/deudas?idagente=${idagente}&fecha=${fechaSistema}&tabconf=${"configproduccion"}&condic=${"tipodeuda=2"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setDeuda(deu);
          setHistorico(his);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        //setActivate(false);
      });
  };

  const procesarDeclaracion = () => {
    let endpoint = `${op.conexion}/api/produccion/actualizardjuradaproduccion`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            setActivate(false);

            setDesde(0);
            setMensaje({
              mostrar: true,
              titulo: "Procesar Declaración",
              texto:
                "La declaración ha sido procesada de manera satisfactoria.",
              icono: "exito",
            });
            setContar(1);
            setContar5(1);
            blanquear();
            let tipDec =
              radioTipo === "2" && cmbQuincena.current.value === "2"
                ? "3"
                : radioTipo;
            seleccionarDjurada(tipDec);
            SelectDeudaAgenProd(props.agente.idagente);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const eliminaDeclaracion = () => {
    let endpoint = `${op.conexion}/api/produccion/eliminardjuradaproduccion`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data) {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Eliminar Declaración",
              texto:
                "La declaración del mes de " +
                cmbMes.current[cmbMes.current.selectedIndex].text +
                " se eliminó de manera satisfactoria.",
              icono: "exito",
            });
            setDesde(0);
            setContar(1);
            setContar5(1);
            blanquear();
            let tipDec =
              radioTipo === "2" && cmbQuincena.current.value === "2"
                ? "3"
                : radioTipo;
            seleccionarDjurada(tipDec);
            SelectDeudaAgenProd(props.agente.idagente);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setOperacionPer(0);
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setMostrar1(false);
    setTitulo2("");
    setMsg2("");
    setActivate(false);
    setDeshabilitadoP(true);
    setDeshabilitadoI(false);
    setContar4(1);
    setRecords([]);
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtReintegro.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";
    txtEstimado.current.value = "0,00";
  };

  const seleccionarDjurada = (tipoDec) => {
    setActivate(true);
    setContar(0);
    selectDjurada(
      props.agente.idagente,
      parseInt(cmbAnio.current.value, 10),
      cmbMes.current[cmbMes.current.selectedIndex].text,
      parseInt(tipoDec, 10)
    );
  };

  const handleChangeRadio = (event) => {
    event.preventDefault();
    setContar3(0);
    setRadioTipo(event.target.value);
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    txtReintegro.current.value = "0,00";
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";
    txtEstimado.current.value = "0,00";
    if (event.target.value === "1") {
      setVisibleRegu("visible");
      setVisibleDefi("hidden");
      if (
        parseInt(
          props.config.aniodesdequincena !== null && cmbAnio.current.value,
          10
        ) >= props.config.aniodesdequincena
      ) {
        if (
          props.config.mesdesdequincena !== null &&
          cmbMes.current.value >= props.config.mesdesdequincena
        ) {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
        } else {
          //setRadioTipo('2');
          setVisibleCmbQ("hidden");
        }
      } else {
        //setRadioTipo('2');
        setVisibleCmbQ("hidden");
      }
    } else if (event.target.value === "2") {
      setVisibleRegu("visible");
      setVisibleDefi("hidden");
      if (
        props.config.aniodesdequincena !== null &&
        parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
      ) {
        if (
          props.config.mesdesdequincena !== null &&
          cmbMes.current.value < props.config.mesdesdequincena
        ) {
          setVisibleCmbQ("visible");
        } else {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
        }
      } else {
        setRadioTipo("1");
        setVisibleCmbQ("hidden");
      }
    }
  };

  /* metodo para cerrar el modal */

  const cancelar = (e) => {
    e.preventDefault();
    setContar(1);
    setContar5(1);
    blanquear();
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 0) {
      setActivate(true);
      procesarDeclaracion();
    } else {
      setActivate(true);
      eliminaDeclaracion();
    }
  };

  const salir = (e) => {
    e.preventDefault();
    props.onHideCancela();
    setContar(1);
    setContar5(1);
    setContar3(1);
    blanquear();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setLiquidador(obj.liquidador);

    //setPermisoElimDecla(JSON.parse(localStorage.getItem('permisos')).accdeclaraciones);
    //setPermisoAcred(JSON.parse(localStorage.getItem('permisos')).accacreditacion);
    var nanio = [];
    var aini = 2008;
    var afin = parseInt(localStorage.getItem("anioactu"), 10);
    for (let i = 0; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    setAnio(nanio);
    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (props.tabclaseprodxagen) {
      setClaseProdxAgen(props.tabclaseprodxagen);
    }
  }, [props.tabclaseprodxagen, props.agente, props.operacion, radioTipo]);

  useEffect(() => {
    if (contar3 === 0 && radioTipo && cmbAnio.current && cmbMes.current) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      setContar3(1);
      seleccionarDjurada(tipDec);
    }
  }, [contar3]);

  useEffect(() => {
    if (contar4 === 0 && records) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      setContar4(1);
      setContar6(0);
      selectDatCal(
        parseInt(props.agente.idagente, 10),
        cmbAnio.current.value,
        cmbMes.current.value,
        tipDec,
        fechaSistema
      );
    }
  }, [records]);

  const handleCmbMes = (event) => {
    event.preventDefault();
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    //txtReintegro.current.value = '0,00';
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";
    //txtEstimado.current.value = '0,00';

    let tipDec =
      radioTipo === "2" && cmbQuincena.current.value === "2" ? "3" : radioTipo;
    if (
      props.config.aniodesdequincena !== null &&
      parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
    ) {
      if (
        props.config.mesdesdequincena !== null &&
        event.target.value >= props.config.mesdesdequincena
      ) {
        if (tipDec === "1") {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
          tipDec = "2";
        }
      } else {
        if (tipDec === "2") {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
          tipDec = "1";
        }
      }
    } else {
      if (tipDec === "2") {
        setVisibleCmbQ("hidden");
        setRadioTipo("1");
        tipDec = "1";
      }
    }
    seleccionarDjurada(tipDec);
    //alert(cmbMes.current[cmbMes.current.selectedIndex].text);
  };

  const handleCmbAnio = (event) => {
    event.preventDefault();
    txtTotalImpuesto.current.value = "0,00";
    txtMontoTotal.current.value = "0,00";
    txtSaldoFavor.current.value = "0,00";
    txtDeducible.current.value = "0,00";
    //txtReintegro.current.value = '0,00';
    txtCreditoFiscal.current.value = "0,00";
    txtRetenciones.current.value = "0,00";
    txtIntereses.current.value = "0,00";
    txtRecargo.current.value = "0,00";

    let tipDec =
      radioTipo === "3" && cmbQuincena.current.value === "2" ? "4" : radioTipo;
    if (
      props.config.aniodesdequincena !== null &&
      parseInt(event.target.value, 10) >= props.config.aniodesdequincena
    ) {
      if (
        props.config.mesdesdequincena !== null &&
        cmbMes.current.value >= props.config.mesdesdequincena
      ) {
        if (tipDec === "1") {
          setVisibleCmbQ("visible");
          setRadioTipo("2");
          tipDec = "2";
        }
      } else {
        if (tipDec === "2") {
          setRadioTipo("1");
          setVisibleCmbQ("hidden");
          tipDec = "1";
        }
      }
    } else {
      if (tipDec === "2") {
        setVisibleCmbQ("hidden");
        setRadioTipo("1");
        tipDec = "1";
      }
    }
    seleccionarDjurada(tipDec);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Las actividades a declarar no deben estar vacias.",
        icono: "informacion",
      });
      sigue = false;
      setTabIndex(0);
    }

    if (sigue) {
      var clasexagen = [];
      var djur = [];
      var peri = 0;
      var totdecla = parseFloat(0.0);
      var totpag = parseFloat(0.0);
      var fecdec;

      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? parseInt("3")
          : parseInt(radioTipo);

      for (let i = 0; i < records.length; i++) {
        if (i === 0) {
          fecdec = records[i].fechadeclaracion;
        }
        totdecla = totdecla + parseFloat(records[i].montodeclarado);
        totpag = totpag + parseFloat(records[i].montoapagar);
        clasexagen.push({
          idclaseproduccion: records[i].idclaseproduccion,
          montodeclarado: records[i].montodeclarado,
          montoapagar: records[i].montoapagar,
        });
      }

      djur.push({
        iddjurada: operacion === 1 ? 0 : idDjur,
        montototaldeclarado: totdecla,
        montototalapagar: totpag,
        fechadeclaracion: fecdec,
        anio: cmbAnio.current.value,
        mes: cmbMes.current[cmbMes.current.selectedIndex].text,
        nummes: cmbMes.current.value,
        tipo: tipDec,
        liquidador: idUsuario,
        valorpetro: props.config.valorpetro,
        //reintegro: txtReintegro.current.value.replace(/\./g, '').replace(',', '.'),
        retenciones: txtRetenciones.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        creditofavor: txtCreditoFiscal.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        recargo: txtRecargo.current.value.replace(/\./g, "").replace(",", "."),
        interes: txtIntereses.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        multa: txtMulta.current.value.replace(/\./g, "").replace(",", "."),
      });

      //setActivate(true);
      setContar2(0);
      setBody({
        idagen: parseInt(props.agente.idagente, 10),
        fechasis: fechaSistema,
        idusu: idUsuario,
        djur: JSON.stringify(djur),
        clasexagen: JSON.stringify(clasexagen),
        dirip: localStorage.getItem("ip"),
        dirmac: localStorage.getItem("mac"),
        peri: props.config.peripago,
        numpago: props.config.numpago,
        txtrif: txtRif.current.value,
      });
      setDesde(0);
      let msg = "Esta Seguro de Procesar la Declaración?.";
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    } else {
      //setMostrar(true);
    }
  };

  const handlerClickTab = (index, lastIndex, event) => {
    setTabIndex(index);
  };

  /*  const validarCapcha = () => {
     
         var valido = ValidCaptcha();
         
         if (valido) {
             setMostrar7(false);
             setTitulo("Corfirmar");
             if (operacion === 1) {
                 setMsg("Esta seguro de registrar el contibuyente con estos datos?");
             } else if (operacion === 2) {
                 setMsg("Esta seguro de modificar el contibuyente con estos datos?");
             } else if (operacion === 3) {
                 setMsg("Esta seguro de eliminar el contibuyente?");
             }
 
             setMostrar1(true);
         }
      
 
     } */

  /*    const handleCancelaCapcha = () => {
           setMostrar7(false);
       }*/

  const agregarActividades = (event) => {
    event.preventDefault();
    if (props.tabclaseprodxagen.length > 0) {
      setClaseProdxAgen(props.tabclaseprodxagen);
      setOperacion(1);
      setContar5(0);
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? "3"
          : radioTipo;
      selectUT(
        parseInt(props.agente.idagente, 10),
        cmbAnio.current.value,
        cmbMes.current.value,
        tipDec,
        fechaSistema,
        totDeuda.trim()
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto:
          "No hay actividades asociadas para el año: " + cmbAnio.current.value,
        icono: "informacion",
      });
    }
  };

  const eliminarDeclaracion = () => {
    if (records.length > 0) {
      let tipDec =
        radioTipo === "2" && cmbQuincena.current.value === "2"
          ? parseInt("3")
          : parseInt(radioTipo);
      //setActivate(true);
      setContar7(0);
      setBody({
        cmes: cmbMes.current[cmbMes.current.selectedIndex].text,
        dirip: localStorage.getItem("ip"),
        dirmac: localStorage.getItem("mac"),
        fechasis: fechaSistema,
        idagen: parseInt(props.agente.idagente, 10),
        idusu: idUsuario,
        montotot: txtMontoTotal.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        nanio: parseInt(cmbAnio.current.value),
        nmes: parseInt(cmbMes.current.value),
        tipodec: tipDec,
      });
      setDesde(1);
      let msg = "Esta Seguro de Eliminar la Declaración?.";
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto:
          "No hay actividades asociadas para el año: " + cmbAnio.current.value,
        icono: "informacion",
      });
    }
  };

  const cerrarModalAgragarActi = () => {
    setClaseProdxAgen(props.tabactixcomer);
    setMostrar2(false);
  };

  const validarAgregarActi = (claseProdxAgen) => {
    setDeshabilitadoP(false);
    setContar4(0);
    setRecords(claseProdxAgen);
    setMostrar2(false);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (
        event.target.id === "inputReintegro" ||
        event.target.id === "inputRetenciones"
      ) {
        var monDedu;
        var totPagar;
        var sFavor;
        //monDedu = parseFloat(txtReintegro.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtRetenciones.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtCreditoFiscal.current.value.replace(/\./g, '').replace(',', '.')) + parseFloat(txtMontoDescuento.current.value.replace(/\./g, '').replace(',', '.'));
        monDedu =
          parseFloat(
            txtReintegro.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtRetenciones.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtCreditoFiscal.current.value.replace(/\./g, "").replace(",", ".")
          );
        monDedu = Math.round(monDedu * Math.pow(10, 2)) / Math.pow(10, 2);
        totPagar =
          parseFloat(
            txtTotalImpuesto.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtRecargo.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtIntereses.current.value.replace(/\./g, "").replace(",", ".")
          ) +
          parseFloat(
            txtMulta.current.value.replace(/\./g, "").replace(",", ".")
          ) -
          monDedu -
          parseFloat(
            txtEstimado.current.value.replace(/\./g, "").replace(",", ".")
          );
        totPagar = Math.round(totPagar * Math.pow(10, 2)) / Math.pow(10, 2);

        if (totPagar < 0.0) {
          sFavor = totPagar * -1;
          sFavor = Math.round(sFavor * Math.pow(10, 2)) / Math.pow(10, 2);
          totPagar = parseFloat(0.0);
        } else {
          sFavor = parseFloat(0.0);
        }
        txtDeducible.current.value = formatMoneda(
          monDedu.toString().replace(".", ","),
          ",",
          ".",
          2
        );
        txtSaldoFavor.current.value = formatMoneda(
          sFavor.toString().replace(".", ","),
          ",",
          ".",
          2
        );
        txtMontoTotal.current.value = formatMoneda(
          totPagar.toString().replace(".", ","),
          ",",
          ".",
          2
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputDeducible") {
          btnSalir.current.focus();
        } else if (
          event.target.id === "inputReintegro" ||
          event.target.id === "inputRetenciones"
        ) {
          btnProcesar.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  /*    const imprimirDeclaracion = () => {
   
           var reporte = '';
           var sql2 = '';
           var sql = '';
           var sql1 = '';
           var sql3 = '';
   
          let tipDec = radioTipo === '3' && cmbQuincena.current.value === '2' ? '4' : radioTipo;
   
           if (tipDec === '1') {
               sql2 = cmbAnio.current.value;
               sql = txtIdAgente.current.value;
               sql1 = cmbAnio.current.value
               reporte = '';
               sql3 = records[0].fechadeclaracion;
               if (espiritu === 9 || espiritu === 12) {
                   reporte = 'ForDeclaracionDefinitivaXYAraure';
               } else if (espiritu === 11) {
                   reporte = 'ForDeclaracionDefinitivaXYaritagua';
               } else {
                   reporte = 'ForDeclaracionDefinitivaXY';
               }
   
               window.open(op.reportes + "reporte=" + reporte + "&ID=" + sql + "&DEFINITIVA=" + sql1 + "&FECHADECLARACION=" + sql3
                   + "&AFAVOR=" + txtSaldoFavor.current.value + "&DEDUCIBLE=" + txtDeducible.current.value + "&NOMELA=" + liquidador,
                   "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
           } else if (tipDec === '0') {
               sql2 = cmbMes.current[cmbMes.current.selectedIndex].text;
              
               sql = txtIdAgente.current.value;
               sql1 = cmbAnio.current.value
               reporte = 'ForDeclaracionEstimada';
               window.open(op.reportes + "reporte=" + reporte + "&CONDICION=" + sql + "&AÑO=" + sql1 + "&MES=" + sql2 + "&NOMELA=" + liquidador, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
           } else if (tipDec === '2' || tipDec === '3' || tipDec === '4') {
               sql2 = cmbMes.current[cmbMes.current.selectedIndex].text;
              
               sql = txtIdAgente.current.value;
               sql1 = cmbAnio.current.value
               sql3 = tipDec;
               var deducible = txtDeducible.current.value === '' ? '0,00' : txtDeducible.current.value;
               var recargo = txtRecargo.current.value === '' ? '0,00' : txtRecargo.current.value;
               var multa = txtMulta.current.value === '' ? '0,00' : txtMulta.current.value;
               var reintegro = txtReintegro.current.value === '' ? '0,00' : txtReintegro.current.value;
               reporte = 'ForDeclaracionMensual';
               window.open(op.reportes + "reporte=" + reporte + "&CONDICION=" + sql + "&AÑO=" + sql1 + "&MES=" + sql2 + "&DEDUCIBLE=" + deducible + "&RECARGO=" + recargo + "&MULTA=" + multa + "&REINTEGRO=" + reintegro + "&AFAVOR=" + txtSaldoFavor.current.value + "&NOMELA=" + liquidador + "&TIPODECLA=" + sql3, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
           }
   
       } */

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisibleCmbQ("hidden");
        setContar4(1);
        setRecords([]);
        setContar3(0);
        setRadioTipo("1");
        setVisibleRegu("visible");
        setVisibleDefi("hidden");
        if (anio) {
          cmbAnio.current.value = anio[anio.length - 1].anio;
        }

        if (
          props.config.aniodesdequincena !== null &&
          parseInt(cmbAnio.current.value, 10) >= props.config.aniodesdequincena
        ) {
          if (
            props.config.mesdesdequincena !== null &&
            cmbMes.current.value >= props.config.mesdesdequincena
          ) {
            setVisibleCmbQ("visible");
            setRadioTipo("1");
          } else {
            setVisibleCmbQ("hidden");
          }
        } else {
          setVisibleCmbQ("hidden");
        }
        props.operacion < 3 ? txtRif.current.focus() : btnSalir.current.focus();
        /*var img = document.getElementById('img1');
                img.src = props.efiscals ? op.imagenes+'/imagen?img=' + props.efiscals[0].nombrelogo : '';*/
        //setContar(0);
        //setDeshabilitado(props.deshabilitado);

        setOperacion(props.operacion);
        setIdUsuario(props.idusuario);
        //setRecords(props.tabactixcomer ? props.tabactixcomer : []);
        setClaseProdxAgen(
          props.tabclaseprodxagen ? props.tabclaseprodxagen : []
        );
        //setOperacion(0);
        setTabIndex(0);
        setContar1(0);
        setDeuda(props.tabdeuda);
        setHistorico(props.tabpago);
        setTotDeuda(props.totdeuda);
        //setcreditoCome(formatMoneda(props.comercio.credito.toString().replace('.', ','), ',', '.', 2));
        /*  setCreditoCome(props.comercio.credito); */
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>
          Registro de Declaraciones Juradas
        </Modal.Title>
        <button
          ref={btnSalir}
          disabled={!deshabilitadoP}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} />
        <TabClaseProducDeclara
          show={mostrar2}
          titulo={titulo1}
          mensaje={msg1}
          onHideCancela={cerrarModalAgragarActi}
          onHideAcepta={validarAgregarActi}
          operacion={operacion}
          tabaclaseprodxagen={claseProdxAgen}
          idagente={props.agente ? props.agente.idagente : ""}
          mes={
            cmbMes.current
              ? cmbMes.current[cmbMes.current.selectedIndex].text
              : ""
          }
          nmes={cmbMes.current ? cmbMes.current.value : ""}
          anio={cmbAnio.current ? cmbAnio.current.value : ""}
          tipodecla={
            radioTipo === "2" &&
            cmbAnio.current &&
            cmbQuincena.current.value === "2"
              ? "3"
              : radioTipo
          }
          datoCalculo={datoUT}
          totdeuda={totDeuda}
          config={props.config}
        />
        <div
          className="px-3"
          style={{ height: "80vh", margin: 0, overflow: "scroll" }}
        >
          <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
            <li className="nav-item " role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-1"
                role="tab"
                aria-controls="ex-with-icons-tabs-1"
                aria-selected="true"
              >
                <i className="fas mx-2 fa-folder-minus"></i>Declaraciones
                Juradas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#55acee" }}
                id="ex-with-icons-tab-2"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-2"
                role="tab"
                aria-controls="ex-with-icons-tabs-2"
                aria-selected="false"
              >
                {" "}
                <i className="fas mx-2 fa-money-bill"></i> Relación de Deuda
                Vencida
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-light rounded"
                style={{ backgroundColor: "#F93154" }}
                id="ex-with-icons-tab-3"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-3"
                role="tab"
                aria-controls="ex-with-icons-tabs-3"
                aria-selected="false"
              >
                <i className="fas mx-2 fa-credit-card"></i>Relación de Pagos
              </a>
            </li>
          </ul>

          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="ex-with-icons-tabs-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div>
                <div
                  className="row rounded py-2 px-0 d-flex justify-content-between"
                  style={{ margin: 0, padding: 0 }}
                >
                  <div className="row col-md-12 d-flex p-0 px-2 justify-content-between">
                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Código:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtIdAgente}
                        className="form-control form-control-sm "
                        defaultValue={props.agente ? props.agente.idagente : ""}
                        id="inputCodigo"
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Año:
                      </label>
                      <select
                        name=""
                        disabled={!deshabilitadoP}
                        ref={cmbAnio}
                        className="form-control form-control-sm "
                        onChange={handleCmbAnio}
                        style={styleInput}
                      >
                        {anio &&
                          anio.map((a) => (
                            <option key={a.anio} value={a.anio}>
                              {a.anio}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Mes:
                      </label>
                      <select
                        name=""
                        disabled={!deshabilitadoP}
                        ref={cmbMes}
                        className="form-control form-control-sm"
                        onChange={handleCmbMes}
                        style={styleInput}
                      >
                        <option key="0" value="1">
                          ENERO
                        </option>
                        <option key="1" value="2">
                          FEBRERO
                        </option>
                        <option key="2" value="3">
                          MARZO
                        </option>
                        <option key="3" value="4">
                          ABRIL
                        </option>
                        <option key="4" value="5">
                          MAYO
                        </option>
                        <option key="5" value="6">
                          JUNIO
                        </option>
                        <option key="6" value="7">
                          JULIO
                        </option>
                        <option key="7" value="8">
                          AGOSTO
                        </option>
                        <option key="8" value="9">
                          SEPTIEMBRE
                        </option>
                        <option key="9" value="10">
                          OCTUBRE
                        </option>
                        <option key="10" value="11">
                          NOVIEMBRE
                        </option>
                        <option key="11" value="12">
                          DICIEMBRE
                        </option>
                      </select>
                    </div>

                    <div className="row col-sm-4">
                      <label
                        className="col-sm-5 px-1"
                        style={{ fontWeight: "bold" }}
                      >
                        Tipo Declaración:
                      </label>
                      <div className="form-check form-check-inline col-sm-3 px-0">
                        <input
                          style={
                            !deshabilitadoP
                              ? { pointerEvents: "none", opacity: "0.7" }
                              : {}
                          }
                          className="form-check-input"
                          type="radio"
                          name="radioTipoDecla"
                          value="1"
                          checked={radioTipo === "1"}
                          onChange={handleChangeRadio}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          {"Mensual"}
                        </label>
                      </div>
                      <div className="form-check form-check-inline col-sm-3 px-0">
                        <input
                          style={
                            !deshabilitadoP
                              ? { pointerEvents: "none", opacity: "0.7" }
                              : {}
                          }
                          className="form-check-input"
                          type="radio"
                          name="radioTipoDecla"
                          value="2"
                          checked={radioTipo === "2"}
                          onChange={handleChangeRadio}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineRadio3"
                        >
                          Quincenal
                        </label>
                      </div>
                    </div>

                    <div className="input-group input-group-sm col-sm-2">
                      <label id="inputGroup-sizing-sm">Valor U.C:</label>
                      <div className="col-md-4" style={{ textAlign: "left" }}>
                        <label htmlFor="inputRitm">
                          {props.config
                            ? formatMoneda(
                                props.config.valorpetro
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*        <div className="row col-md-12">
                                        <div className="col-md-3" style={{ visibility: visibleCmbQ }} >
                                            <select name="" disabled={!deshabilitadoP} ref={cmbQuincena} style={{ marginBottom: "5px" }} className="form-control form-control-sm" >
                                                <option key="0" value="1">PRIMERA QUINCENA</option>
                                                <option key="1" value="2">SEGUNDA QUINCENA</option>
                                            </select>
                                        </div>
                                    </div> */}

                  <div className="text-success" style={{ marginTop: "1%" }}>
                    <h3>Datos del Contribuyente</h3>
                    <hr />
                  </div>

                  <div className="col-sm-6 row">
                    <div className="input-group input-group-sm py-1 col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Rif:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtRif}
                        maxLength={15}
                        className="form-control form-control-sm"
                        placeholder="123456789"
                        id="inputRif"
                        defaultValue={
                          props.agente ? props.agente.rif.trim() : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-9">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Denominación Comercial:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtDenominacionCome}
                        className="form-control form-control-sm"
                        defaultValue={
                          props.agente ? props.agente.nombre.trim() : ""
                        }
                        id="inputDenoComer"
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Teléfono:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtTlfContri}
                        className="form-control form-control-sm"
                        id="inputTlfContri"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.agente
                            ? props.agente.telefono !== null
                              ? props.agente.telefono.trim()
                              : ""
                            : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nº de Licencia:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtNumLicencia}
                        className="form-control form-control-sm"
                        defaultValue={
                          props.agente
                            ? props.agente.nrolicenciaproduccion !== null
                              ? props.agente.nrolicenciaproduccion.trim()
                              : ""
                            : ""
                        }
                        id="inputNumLicencia"
                        style={styleInput}
                      />
                    </div>
                  </div>

                  <div className="col-sm-6 row">
                    <div className="input-group input-group-sm py-1 col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nombre Representante:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtNombreRespon}
                        className="form-control form-control-sm"
                        id="inputNomResponsable"
                        defaultValue={
                          props.representante
                            ? props.representante.nombres.trim() +
                              " " +
                              props.representante.apellidos.trim()
                            : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cédula:
                      </label>
                      <input
                        type="text"
                        readOnly
                        ref={txtCedula}
                        className="form-control form-control-sm"
                        id="inputCedula"
                        defaultValue={
                          props.representante ? props.representante.cedula : ""
                        }
                        style={styleInput}
                      />
                    </div>

                    <div className="input-group input-group-sm py-1 col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección:
                      </label>
                      <textarea
                        type="text"
                        readOnly
                        ref={txtDireccionContri}
                        className="form-control form-control-sm"
                        id="inputDireccionContri"
                        defaultValue={
                          props.agente
                            ? props.agente.direccion !== null
                              ? props.agente.direccion.trim()
                              : ""
                            : ""
                        }
                        style={styleInputDirec}
                      />
                    </div>
                  </div>
                </div>

                <div className="row col-md-12" style={{ padding: "5px" }}>
                  <div
                    className="text-success d-flex-justify-content-between row col-sm-12"
                    style={{ marginTop: "1%" }}
                  >
                    <h3 className="col-sm-3">Datos de la Declaración Jurada</h3>
                    <div className="col-sm-6"></div>
                    <div
                      className="col-md-3 d-flex justify-content-end"
                      style={{ padding: 0 }}
                    >
                      <button
                        disabled={deshabilitadoI}
                        className="btn btn-sm btn-primary rounded-pill"
                        onClick={agregarActividades}
                        style={{ fontSize: "10px", height: 30 }}
                      >
                        <i className="fa fa-plus"> Incluir</i>{" "}
                      </button>
                    </div>

                    <hr />
                  </div>
                  <div className="col-md-5">
                    <h3
                      style={{
                        margin: "0",
                        textAlign: "center",
                        color: "blue",
                      }}
                    >
                      {records && records.length > 0 && records[0].pagada
                        ? "La Declaración está Pagada"
                        : ""}
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-12"
                  style={{ backgroundColor: "#ffffff" }}
                >
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        records.map((dju, index) => (
                          <TableRow
                            style={{ padding: "0" }}
                            key={dju.claseproduccion}
                          >
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "center" }}
                            >
                              {dju.codigoclaseproduccion}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "left" }}
                            >
                              {dju.descripcion}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.alicuota.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montodeclarado
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                dju.montoapagar
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: "10px", textAlign: "center" }}
                            >
                              {moment(dju.fechadeclaracion).format(
                                "DD/MM/YYYY"
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
                <div className="row col-md-12" style={{ margin: "0px" }}>
                  <div className="rounder row col-md-3 border border-primary">
                    <div
                      className="col-md-12"
                      style={{ visibility: visibleDefi }}
                    >
                      <h4>Estimado Año Anterior</h4>
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleDefi }}
                    >
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Total Estimado:
                      </label>
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleDefi }}
                    >
                      <input
                        type="text"
                        ref={txtEstimado}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "0px", textAlign: "right" }}
                        id="inputTotalEstimado"
                        defaultValue="0,00"
                        onFocus={seleccionarCampo}
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div
                      className="col-md-12"
                      style={{
                        visibility:
                          (records &&
                            records.length > 0 &&
                            records[0].pagada) ||
                          (records && records.length === 0) ||
                          (permisoElimDecla &&
                            permisoElimDecla.substring(1, 2) !== "1")
                            ? "hidden"
                            : "visible",
                      }}
                    >
                      <button
                        disabled={!deshabilitadoP}
                        className="btn btn-sm btn-danger"
                        style={{ marginTop: "50%" }}
                        onClick={eliminarDeclaracion}
                      >
                        <i className="fa fa-trash-alt">
                          {" "}
                          Eliminar Declaración y Deuda
                        </i>{" "}
                      </button>
                    </div>
                  </div>
                  <div className="row col-md-5" style={{ marginTop: "5px" }}>
                    <div className="col-md-4">
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Saldo a Favor:
                      </label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10">
                        <input
                          type="text"
                          readOnly
                          ref={txtSaldoFavor}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputISLR"
                          defaultValue="0,00"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                    <div
                      className="col-md-4"
                      style={{
                        visibility: "hidden",
                      }} /*style={{ visibility: permisoAcred && (parseInt(permisoAcred, 10) === 0 || permisoAcred.trim() === '' ? 'hidden' : 'visible') }}*/
                    >
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Acreditación:
                      </label>
                    </div>
                    <div
                      className="row col-md-6"
                      style={{
                        visibility: "hidden",
                      }} /*style={{ visibility: permisoAcred && (parseInt(permisoAcred, 10) === 0 || permisoAcred.trim() === '' ? 'hidden' : 'visible') }}*/
                    >
                      <div className="col-md-10">
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtReintegro}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputReintegro"
                          defaultValue="0,00"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                      {/*<div className="col-md-2">
                                                <button disabled={deshabilitado} className="btn  btn-success btn-sm"><i className="fa">Cargar...</i></button>
                                            </div>*/}
                    </div>
                    <div
                      className="col-md-4"
                      style={{ visibility: visibleRegu }}
                    >
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        % Retenciones:
                      </label>
                    </div>
                    <div
                      className="row col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <div className="col-md-10">
                        <input
                          type="text"
                          ref={txtRetenciones}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputRetenciones"
                          defaultValue="0,00"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                      {/*<div className="col-md-2">
                                                <button disabled={deshabilitado} className="btn  btn-success btn-sm"><i className="fa">Cargar...</i></button>
                                        </div>*/}
                    </div>
                    <div className="col-md-4">
                      <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">
                        Credito Fiscal:
                      </label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10">
                        <input
                          type="text"
                          readOnly
                          ref={txtCreditoFiscal}
                          className="form-control form-control-sm"
                          style={{ textAlign: "right" }}
                          id="inputCreditoFiscal"
                          defaultValue="0,00"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                    {/*<div className="col-md-4" style={{ visibility: visibleRegu }} >
                                            <label style={{ marginLeft: "5px" }} htmlFor="inputRitm">%Descuento:</label>
                                        </div>
                                        <div className="row col-md-6" style={{ visibility: visibleRegu }} >
                                            <div className="col-md-10">
                                                <input type="text" readOnly ref={txtPorceDescuento} className="form-control form-control-sm" style={{ textAlign: "right" }} id="inputISLR" defaultValue='0,00' />
                                            </div>
                                            <div className="col-md-2">

                                            </div>
                                        </div>*/}
                    <div className="col-md-4">
                      <label
                        style={{ marginLeft: "5px" }}
                        htmlFor="inputRitm"
                      ></label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10"></div>
                      <div className="col-md-2"></div>
                    </div>
                    <div className="col-md-4">
                      <label
                        style={{ marginLeft: "5px" }}
                        htmlFor="inputRitm"
                      ></label>
                    </div>
                    <div className="row col-md-6">
                      <div className="col-md-10"></div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="rounder row col-md-4 border border-primary">
                    <div className="col-md-12">
                      <h4>Totales</h4>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Total Impuesto:</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtTotalImpuesto}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "5px", textAlign: "right" }}
                        id="inputNumRegistro"
                        defaultValue="0,00"
                      />
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <label htmlFor="inputRitm">
                        {props.config
                          ? formatMoneda(
                              props.config.porrecargo
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            ) + "% Recargos:"
                          : "% Recargos:"}
                      </label>
                    </div>

                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <input
                        type="text"
                        readOnly
                        ref={txtRecargo}
                        className="form-control form-control-sm"
                        style={{ marginBottom: "5px", textAlign: "right" }}
                        id="inputFechaInscripcion"
                        defaultValue="0,00"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">
                        {props.config
                          ? formatMoneda(
                              props.config.porinteres
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            ) + "% Intereses:"
                          : "% Intereses:"}
                      </label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtIntereses}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputISLR"
                        defaultValue="0,00"
                      />
                    </div>
                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <label htmlFor="inputRitm">Multa:</label>
                    </div>

                    <div
                      className="col-md-6"
                      style={{ visibility: visibleRegu }}
                    >
                      <input
                        type="text"
                        readOnly
                        ref={txtMulta}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputCapPag"
                        defaultValue="0,00"
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Impuesto Deducible:</label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtDeducible}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputDeducible"
                        defaultValue="0,00"
                        onFocus={seleccionarCampo}
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    {/*<div className="col-md-6" style={{ visibility: visibleRegu }} >
                                            <label htmlFor="inputRitm">Monto Descuento:</label>
                                        </div>

                                        <div className="col-md-6" style={{ visibility: visibleRegu }} >
                                            <input type="text" readOnly ref={txtMontoDescuento} className="form-control form-control-sm" style={{ textAlign: "right", marginBottom: "5px" }} id="inputCapSub" defaultValue='0,00' />
                                        </div>*/}
                    <div className="col-md-6">
                      <label htmlFor="inputRitm">Monto Total a Pagar Bs:</label>
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        readOnly
                        ref={txtMontoTotal}
                        className="form-control form-control-sm"
                        style={{ textAlign: "right", marginBottom: "5px" }}
                        id="inputCapSub"
                        defaultValue="0,00"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-sm-12 row d-flex justify-content-end py-2"
                style={{ marginTop: "2%" }}
              >
                <button
                  ref={btnProcesar}
                  disabled={deshabilitadoP}
                  /*disabled={permisoElimDecla ? permisoElimDecla.substring(2, 3) !== "1" ? true : deshabilitadoP : true}*/ onClick={
                    onChangeValidar
                  }
                  className="mx-2 rounded-pill btn btn-success col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-check-circle"> Procesar Declaración</i>
                </button>
                <button
                  ref={btnImprimir}
                  disabled={
                    records && records.length > 0 && deshabilitadoP
                      ? false
                      : true
                  }
                  /* onClick={imprimirDeclaracion} */ className="mx-2 rounded-pill btn btn-primary col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-print"> Imprimir</i>
                </button>
                <button
                  ref={btnCancela}
                  disabled={deshabilitadoP}
                  onClick={cancelar}
                  className="mx-2 rounded-pill btn btn-secondary col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fas fa-window-close"> Cancelar</i>
                </button>
                <button
                  ref={btnSalir}
                  disabled={!deshabilitadoP}
                  onClick={salir}
                  className="mx-2 rounded-pill btn btn-danger col-md-2"
                  style={{ height: "35px", fontSize: "12px" }}
                >
                  <i className="fa fa-sign-out"> Salir</i>
                </button>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-2"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-2"
            >
              <TablaDeudaProduc
                tabdeuda={deuda}
                credito={props.agente ? props.agente.credito : "0,00"}
              />
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-3"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-3"
            >
              <TablaHistoricoProduc tabpago={historico} />
            </div>
          </div>
          {/* Tabs content */}
        </div>
      </Modal.Body>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/modalDeclacracionPro.js